import React from 'react';
import { Box } from '@mui/material';
import type { GeoJsonFeature } from '../../utils/ogc';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';


const fmtString = (v: string | null) => (v == null || v === '' ? '—' : v);
const fmtDate = (v: Date | null) => (v ? new Date(v).toLocaleString() : '—');
const fmtNum = (v: number | null) => (v == null ? '—' : Number(v).toFixed(1));



{/*  */}

export default function MetadataList({ feature }: { feature: GeoJsonFeature; currentTime?: Date; onSelect?: (f: GeoJsonFeature) => void }) {
  const fields = React.useMemo<GridColDef[]>(() => [
    { field: 'id', headerName: 'Deployment ID', flex: 1, minWidth: 150, valueFormatter: fmtString },
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 180, valueFormatter: fmtString },
    { field: 'neighborhood', headerName: 'Neighborhood', flex: 1, minWidth: 150, valueFormatter: fmtString },
    { field: 'borough', headerName: 'Borough', flex: 1, minWidth: 120, valueFormatter: fmtString },
    { field: 'date_deployed', headerName: 'Date Deployed', width: 180, valueFormatter: fmtDate },
    { field: 'date_down', headerName: 'Date Down', width: 180, valueFormatter: fmtDate },
    { field: 'sensor_mount', headerName: 'Sensor Mount', flex: 1, minWidth: 150, valueFormatter: fmtString },
    { field: 'mounted_over', headerName: 'Mounted Over', flex: 1, minWidth: 150, valueFormatter: fmtString },
    { field: 'flood_event_count', headerName: 'Flood Events Observed', type: 'number', width: 160, valueFormatter: fmtNum },
    { field: 'max_depth_inches_of_last_flood', headerName: 'Max Depth (Last Flood) (in)', type: 'number', width: 180, valueFormatter: fmtNum },
    { field: 'max_depth_inches_of_any_flood', headerName: 'Max Depth (Any Flood) (in)', type: 'number', width: 180, valueFormatter: fmtNum },
    { field: 'last_flood_time', headerName: 'Last Flood', width: 180, valueFormatter: fmtDate },
    { field: 'last_flood_end_time', headerName: 'Last Flood End', width: 180, valueFormatter: fmtDate },
  ], []);

  const rows = React.useMemo(() => {
    return fields.map((col) => ({ id: col.field, headerName: col.headerName, value: col.valueFormatter(feature.properties[col.field as keyof typeof feature.properties]) }));
  }, [feature, fields]);  
  const columns = React.useMemo<GridColDef[]>(() => ([
    { field: 'headerName', headerName: 'Field', flex: 1, minWidth: 180, sortable: false, filterable: false, valueFormatter: fmtString },
    { field: 'value', headerName: 'Value', flex: 1, minWidth: 200, sortable: false, filterable: false, valueFormatter: fmtString },
  ]), []);

  return (
          <DataGrid
            rows={rows}
            columns={columns}
            density="compact"
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            hideFooterPagination
            sx={{
              bgcolor: 'transparent',
              border: 'none',
              height: 'auto',
              // '& .MuiDataGrid-columnHeaders': { fontSize: 12, minHeight: { xs: 30, sm: 36 }, maxHeight: { xs: 30, sm: 36 } },
              // '& .MuiDataGrid-cell': { fontSize: 12, py: { xs: 0.25, sm: 0.5 } },
              // '& .MuiDataGrid-row.inactive .MuiDataGrid-cell': {
              //   color: 'text.disabled',
              // },
            }}
            slots={{
              columnHeaders: () => null,
            }}
          />
    );
};